import * as React from 'react';
import styled from 'styled-components';
import { wireAuthConsumer } from 'automation-ui-core/context/AuthContext';
import { useIconSize, LockedIcon } from 'foundations-assets';
import { useUpgradeModal } from 'ui-addon-upgrades/ums/useUpgradeModal';
import ConnectorButton from 'automation-ui-canvas/components/canvas/ConnectorButton';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const LOCK_ICON_SIZE_TOKEN = '200';
const LOCK_ICON_SPACE_TOKEN = '100';
const ContextualCanvasUpgradeButtonWrapper = styled.div.withConfig({
  displayName: "ContextualCanvasUpgradeButton__ContextualCanvasUpgradeButtonWrapper",
  componentId: "pj8tt2-0"
})(["display:flex;align-items:center;gap:", ";margin-left:calc( ", " + ", " );"], ({
  theme
}) => theme.space[LOCK_ICON_SPACE_TOKEN], ({
  iconSize = '14px'
}) => iconSize, ({
  theme
}) => theme.space[LOCK_ICON_SPACE_TOKEN]);
export const ContextualCanvasUpgradeButton = ({
  disabled,
  disabledMessage,
  edge,
  upgradeModalKey
}) => {
  const {
    openUpgradeModal
  } = useUpgradeModal(upgradeModalKey);
  const iconSize = useIconSize(LOCK_ICON_SIZE_TOKEN);
  if (!edge.getShouldShowAddControl()) {
    return null;
  }
  return (
    /*#__PURE__*/
    // @bend-expect trellis-tokenized
    _jsxs(ContextualCanvasUpgradeButtonWrapper, {
      iconSize: iconSize,
      children: [/*#__PURE__*/_jsx(ConnectorButton, {
        edge: edge,
        showEdgeTooltips: false,
        onClick: openUpgradeModal,
        "data-test-id": "single-connector-upgrade-point",
        disabled: disabled,
        tooltip: disabledMessage,
        placement: "left"
      }), /*#__PURE__*/_jsx(LockedIcon, {
        color: "icon-core-subtle",
        size: LOCK_ICON_SIZE_TOKEN,
        "data-test-id": "lock-upgrade-point"
      })]
    })
  );
};
export default wireAuthConsumer(ContextualCanvasUpgradeButton);